import { render, staticRenderFns } from "./IntensivesMain.vue?vue&type=template&id=5877a63a&scoped=true&"
import script from "./IntensivesMain.vue?vue&type=script&lang=js&"
export * from "./IntensivesMain.vue?vue&type=script&lang=js&"
import style0 from "./IntensivesMain.vue?vue&type=style&index=0&id=5877a63a&prod&lang=scss&"
import style1 from "./IntensivesMain.vue?vue&type=style&index=1&id=5877a63a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5877a63a",
  null
  
)

export default component.exports